'use strict';

var _mount = require('../../app/helpers/mount');

var _Prescription = require('../../app/Prescription.vue');

var _Prescription2 = _interopRequireDefault(_Prescription);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var body = document.getElementsByTagName('body')[0];

if (body.classList.contains('template-product')) {
  (0, _mount.mountVue)('#PrescriptionFlow', _Prescription2.default);
}